<script>
    import {Image} from 'vant';
    import Config from "@/config";
    import Size from '@/mixins/size';
    import {getCouponDetail} from '@/api';
    import {formatTime} from '@/libs/util';

    export default {
        mixins: [
            Size
        ],
        components: {
            [Image.name]: Image
        },
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                coupon: null
            }
        },
        watch: {
            $route(to) {
                if (to.name === 'couponUse') {
                    this.loadCouponData(to.params.id);
                }
            }
        },
        mounted() {
            window.document.title = '速电通-券详情';

            this.loadCouponData(this.id);
        },
        computed: {
            getAt() {
                return this.coupon ? formatTime(new Date(this.coupon.createdAt)) : '';
            },
            qrCode() {
                let baseUrl = process.env.NODE_ENV === 'development' ? Config.baseUrl.dev : Config.baseUrl.pro;
                return this.coupon ? baseUrl + 'storage/qr?qr=coupon://' + this.coupon.code + '&width=152&height=152' : '../assets/images/qr.png'
            }
        },
        methods: {
            loadCouponData(id) {
                getCouponDetail(id).then(response => {
                    if (response.data.code === Config.successCode) {
                        this.coupon = response.data.body;
                    }
                });
            }
        }
    }
</script>

<template>
    <div id="coupon">
        <div :style="{height: (height - 56) + 'px'}" class="content">
            <div class="logo">
                <img class="image" src="../assets/images/logo-v.png"/>
            </div>
            <div v-if="coupon" class="info">
                <van-image radius="4" width="83" height="60" lazy-load :src="coupon.cover"/>
                <div class="right">
                    <div class="title">{{coupon.title}}</div>
                    <div class="time">领取时间：{{getAt}}</div>
                    <div class="score">{{coupon.score}}积分</div>
                </div>
            </div>
            <div v-if="coupon" class="split">
                <div class="left sdt-half-circle"></div>
                <div class="line"></div>
                <div class="right sdt-half-circle"></div>
            </div>
            <div v-if="coupon" class="code">
                <div class="image">
                    <img class="image" :src="qrCode"/>
                </div>
                <div class="number">编号：{{coupon.code}}</div>
            </div>
            <div v-if="coupon" class="tip">
                <div>请将二维码向现场工作人员展示</div>
                <div class="row2">工作人员核销后即可领取商品</div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    #coupon {
        padding: 12px;
        background: #009251;
    }

    #coupon .content {
        margin-top: 32px;
        border-radius: 8px;
        background-color: white;
    }

    #coupon .content .logo {
        top: 12px;
        width: 64px;
        height: 64px;
        z-index: 999;
        position: fixed;
        border-radius: 50%;
        left: calc(50% - 32px);
        background-color: white;
        box-shadow: 0 2px 3px 0 rgba(0, 146, 81, 0.44);

        display: flex;
        align-items: center;
        justify-content: center;
    }

    #coupon .content .logo .image {
        width: 60px;
        height: 60px;
    }

    #coupon .content .info {
        margin-top: 32px;
        padding: 48px 12px 12px 12px;

        display: flex;
        align-items: center;
    }

    #coupon .content .info .right {
        margin-left: 12px;
    }

    #coupon .content .info .right .title {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
    }

    #coupon .content .info .right .time {
        color: #999999;
        font-size: 12px;
        font-weight: 500;
        margin-top: 6px;
    }

    #coupon .content .info .right .score {
        color: #009251;
        font-size: 14px;
        font-weight: bold;
        margin-top: 6px;
    }

    #coupon .content .split {
        display: flex;
        align-items: center;
    }

    #coupon .content .split .left {
        transform: rotate(180deg) translateX(1px);
    }

    #coupon .content .split .line {
        flex: 1;
        border-top: 1px dashed #E5E5E5;
    }

    #coupon .content .split .left,
    #coupon .content .split .right {
        color: #009251;
        background-color: white;
    }

    #coupon .content .code {
        display: flex;
        padding: 32px 0;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }

    #coupon .content .code .image {
        width: 160px;
        height: 160px;
    }

    #coupon .content .code .number {
        margin-top: 4px;
    }

    #coupon .content .code .number,
    #coupon .content .tip {
        color: #999999;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
    }

    #coupon .content .tip .row2 {
        margin-top: 4px;
    }
</style>
